import { render, staticRenderFns } from "./CurrentMagazine.vue?vue&type=template&id=6eef099f&scoped=true&"
import script from "./CurrentMagazine.vue?vue&type=script&lang=js&"
export * from "./CurrentMagazine.vue?vue&type=script&lang=js&"
import style0 from "./CurrentMagazine.vue?vue&type=style&index=0&id=6eef099f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eef099f",
  null
  
)

export default component.exports